<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>Êtes vous sûr de vouloir supprimer votre compte ?</v-card-title>
        <v-card-actions>
          <v-btn @click="deleteAccount">Confirmer</v-btn>
          <v-btn @click="$emit('close')">Annuler</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script setup>
  import { ref } from 'vue';
  import { useAuthStore } from '@/store/AuthStore';
  import snackbarService from '@/services/snackbarService';
  
  const dialog = ref(true);
  const authStore = useAuthStore();
  
  const deleteAccount = async () => {
    try {
        await authStore.deleteAccount();
        await authStore.logout();

        snackbarService.showSnackbar("Le compte a été supprimé avec succès.", 'success')
        dialog.value = false;
    } catch (error) {
      snackbarService.showSnackbar(error, 'error')
    }
  };
  </script>